import { useCallback } from 'react';
import { useMember } from '~/components/Member/Member.hooks';
import { useSecurity, UseSecurityOptions } from '~/components/Security';

export const useLoginSecurity = (options?: Optional<UseSecurityOptions, 'values' | 'validate'>) => {
  const { data } = useMember();
  const validate = useCallback(([{ isLoggedIn }]) => {
    if (!isLoggedIn) {
      return 'UNAUTHORIZED';
    }
  }, []);

  return useSecurity({
    values: [data],
    validate,
    ...options,
  });
};
